import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import creditcardfraud from "../../Assets/Projects/creditcardfraud.webp";
import emotion from "../../Assets/Projects/emotion.png";
import temperaturefinder from "../../Assets/Projects/temperaturefinder.jpeg";
import portfolio from "../../Assets/Projects/portfolio.jpeg";
import connectme from "../../Assets/Projects/connectme.jpeg";
import eliteengineers from "../../Assets/Projects/eliteengineers.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
           <strong className="purple">Projects </strong>
        </h1>
      
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Portfolio"
              description="Welcome to my online portfolio, a curated collection that provides a comprehensive glimpse into my professional journey and accomplishments. Here, you'll find a showcase of my skills, experiences, and passion for coding, encapsulated in a user-friendly and visually engaging format"
              ghLink="https://github.com/SwaggyRajput"
              demoLink="https://profileharsh.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eliteengineers}
              isBlog={false}
              title="The Elite Engineers"
              description="Immerse yourself in a sleek and user-friendly interface crafted with React. Our design prioritizes a seamless user experience, 
ensuring easy navigation and accessibility for all visitors with user feedback also."
              ghLink="https://github.com/SwaggyRajput/Project30"
              demoLink="https://theeliteengineers.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={connectme}
              isBlog={false}
              title="ConnectMe"
              description="ConnectMe is not just a registration and login website; it's a gateway to seamless digital connections. Experience the synergy of 
                React and Express.js as they come together to redefine simplicity, security, and user satisfaction. ConnectMe - Where Users Unite!"
              ghLink="https://github.com/SwaggyRajput/Project18"
              demoLink="https://connnectmee.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={temperaturefinder}
              isBlog={false}
              title="Temperaturefinder"
              description=" TemperatureFinder is powered by a weather API, ensuring users receive the latest and most accurate temperature data for their 
                selected locations. The dynamic integration allows for real-time updates, keeping users informed about current weather conditions."
              ghLink="https://github.com/SwaggyRajput/Project22"
              demoLink="https://connnectmee.netlify.app/"              
            />
          </Col>
         

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={creditcardfraud}
              isBlog={false}
              title="Credit Card Fraud Detection"
              description="Developed a predictive model to identify and mitigate fraudulent transactions, contributing to enhanced security measures in 
financial transactions"
              ghLink="https://github.com/SwaggyRajput/Project18"
            //  demoLink="https://connnectmee.netlify.app/"
            />
          </Col>

          

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;